import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { FadeLoader } from "react-spinners";
import toggleDiv from "../../utils/toggleDiv";
import PageHeader from "../../components/PageHeader";
import Alert from "../../components/Alert";
import ListadoEquipoInterno from "./ListadoEquipoInterno";
import ListadoEquipoExterno from "./ListadoEquipoExterno";
import ListadoCaracTecVehiculoDinamico from "./ListadoCaracTecVehiculoDinamico";
import ListadoEspecTecVehiculo from "./ListadoEspecTecVehiculo";
import ListadoAccAduaVehiculo from "./ListadoAccAduaVehiculo";
import ListadoEquiSegVehiculoDinamico from "./ListadoEquiSegVehiculoDinamico";
import ListadoImagenVehiculoDinamico from "./ListadoImagenVehiculoDinamico";
import SeleccionarAdjuntoEcommerce from "./SeleccionaAdjuntoEcommerce";
import ListadoImagenDinamicoEcommerce from "./ListadoImagenDinamicoEcommerce";
import {
  fetchEquiposxVehiculo,
  fetchCaracTecxVehiculo,
  fetchEspecTecxVehiculo,
  fetchAccAduaxVehiculo,
  fetchImagenVehiculo,
  fetchImagenVehiculoEcommerce,
  fetchEquiSegVehiculo,
  loadMantenimiento,
  createEquiSegVeh,
  deleteEquiSegVeh,
  createImagenVeh,
  createImagenVehEcommerce,
  deleteImagenVeh,
  fetchTipoImagen,
  fetchTipoImagenEcommerce,
  updateCarTecVeh,
  fetchCaracterTecnica,
  deleteCarTecVeh,
  createCarTecVeh,
  fetchRutaFirebase,
  updateEquiSegVeh,
  updateEquiVeh,
  updateImagenVeh,
  fetchCodigoAutoImagen,
  fetchListarColorVehiculoSKU,
  fetchListarColorVehiculoInteriorSKU,
} from "../../actions";
import * as firebase from "firebase";

const storage = firebase.storage();
//<88181>
class SkuVehiculoDetalle extends Component {
  //90467
  static hideMessage() {
    document.getElementById('alert').style.display = 'flex';
    setTimeout(() => {
      if (document.getElementById('alert')) {
        document.getElementById('alert').style.display = 'none';
      }
    }, 5000);
  }
  //90467 
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this); //Este es una manera de probar si funciona.
    this.onUpdateItemImagenes = this.onUpdateItemImagenes.bind(this);
    this.onDrop = this.onDrop.bind(this);
    // this.actualizarArrayImgIndTipoWeb = this.actualizarArrayImgIndTipoWeb.bind(
    //   this
    // );
    this.state = {

      // 
      tipoimgEcommerceFiltro: "",
      colorVehiculoEcommerceFiltro: "",
      ecommerceCargaMasTipImg: "",
      ecommerceCargaMasColVeh: "",
      ecommerceCargaMasColTap: "",
      listaEcommerceCargaMas: [],
      //Variable util para grabar onFireBase
      miFile: "",
      file: null,
      //miStorage:'',
      stCodigoAuto: "",
      stPrefijoRuta: "",
      arrevehiculos: [],
      arrecaractecn: [],
      arreimagenes: [],
      arreimagenesEcommMas: [],
      arreimagenesEcommerce: [],
      arreimagenesEcommerceList: [],
      arretipimag: [],
      arretipimagEcommerce: [],
      arretbcaractec: [],
      arreEcommerce: [],
      // paginacion
      pagina: 1,
      // Equipos
      totalRegEquiInter: 0,
      cantRegEquiInter: 0,
      totalRegEquiExter: 0,
      cantRegEquiExter: 0,
      // Caracteristica
      totalRegCaract: 0,
      cantRegCaract: 0,
      // Especificacion
      totalRegEspec: 0,
      cantRegEspec: 0,
      // Accesorios
      totalRegAcces: 0,
      cantRegAcces: 0,
      // Imagen
      totalRegImag: 0,
      cantRegImag: 0,
      // EquiSeg
      totalRegSegVeh: 0,
      cantRegSegVeh: 0,
      estadoTrama: 0,

      //Valores de solo lectura - Edicion
      familia: "",
      marca: "",
      modelo: "",
      configuracion: "",
      skuSap: "",
      variante: "",
      inactivo: "",
      tipoVehiculo: "",
      tipoSku: "",
      combustible: "",
      tipoReporteEuro: "",
      reporteEuro: "",

      listaEquipInter: [],
      listaEquipExter: [],
      listaCaracter: [],
      listaEspecTecn: [],
      listaAccesorio: [],
      listaImagen: [],
      listaEquiSeg: [],
      listaColorVeh: [], //<>90364
      listaColorVehInterior: [], //<>90364
      alertErrorOpenI: false,
      alertSuccessOpenI: false,
      alertErrorOpenD: false,
      alertSuccessOpenD: false,

      //pestaña CARACTERISTICA TECNICA
      alertAdverNroOrden: false,
      alertAdverCarTec: false,
      alertAdverCarTecReq: false,
      //pestaña IMAGEN
      alertAdverTipImgReq: false,
      alertAdverAdjArcReq: false,
      //pestaña EQUIPO SEGURIDAD VEHICULO
      alertAdverEquipoReq: false,
      alertAdverDetalleReq: false,
      isActive: 0,
    };
  }

  onChangetext = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  componentDidMount() {
    let {
      arrevehiculos,
      arreimagenes,
      arreimagenesEcommerce,
      arreimagenesEcommerceList,
      arretipimag,
      arretipimagEcommerce,
      arrecaractecn,
      arretbcaractec,
    } = this.state;
    document.addEventListener("click", toggleDiv, true);
    const { skuvehiculo } = this.props.location.state;
    const { isActive } = this.state;
    if (sessionStorage.getItem("pestania") != isActive) {
      this.setState({ isActive: parseInt(sessionStorage.getItem("pestania")) });
    }

    if (this.props.location.state !== undefined) {
      this.setState({
        familia: skuvehiculo.familia,
        marca: skuvehiculo.marca,
        modelo: skuvehiculo.baumuster,
        configuracion: skuvehiculo.desConfigVeh,
        skuSap: skuvehiculo.skuSap,
        variante: skuvehiculo.variante,
        tipoVehiculo: skuvehiculo.tipoVehiculo,
        tipoSku: skuvehiculo.tipoSku,
        combustible: skuvehiculo.combustible,
        reporteEuro: skuvehiculo.reporteEuro,
        inactivo: skuvehiculo.indInactivo,
      });
    }
    document.addEventListener("click", toggleDiv, true);
    //Cargar los equipos por vehiculo	Interno y externo
    this.props
      .fetchEquiposxVehiculo(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh,
        "29"
      )
      .then(({ payload: { data } }) =>
        this.setState({
          listaEquipInter: data.busqueda,
          totalRegEquiInter: data.totalRegistros,
          cantRegEquiInter: data.busqueda.length,
        })
      );

    this.props
      .fetchEquiposxVehiculo(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh,
        "31"
      )
      .then(({ payload: { data } }) =>
        this.setState({
          listaEquipExter: data.busqueda,
          totalRegEquiExter: data.totalRegistros,
          cantRegEquiExter: data.busqueda.length,
        })
      );

    //Cargar las caracteristicas tecnicas COMBO
    this.props
      .fetchCaracterTecnica(skuvehiculo.codFamilia, skuvehiculo.codMarca)
      .then(({ payload: { data } }) =>
        this.setState({
          arretbcaractec: data.busqueda,
        })
      );

    //Cargar las caracteristicas tecnicas 29
    this.cargarListaCaracterTecnicaVehiculo();
    //Cargar las especificaciones tecnicas
    this.props
      .fetchEspecTecxVehiculo(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh
      )
      .then(({ payload: { data } }) =>
        this.setState({
          listaEspecTecn: data.busqueda,
          totalRegEspec: data.totalRegistros,
          cantRegEspec: data.busqueda.length,
        })
      );

    //Cargar los accesorios aduaneros
    this.props
      .fetchAccAduaxVehiculo(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh
      )
      .then(({ payload: { data } }) =>
        this.setState({
          listaAccesorio: data.busqueda,
          totalRegAcces: data.totalRegistros,
          cantRegAcces: data.busqueda.length,
        })
      );

    //Cargar los tipos de imagenes
    this.props.fetchTipoImagen().then(({ payload: { data } }) =>
      this.setState({
        arretipimag: data.busqueda,
      })
    );

    //Cargar los tipos de imagenes
    this.props.fetchTipoImagenEcommerce().then(({ payload: { data } }) =>
      this.setState({
        arretipimagEcommerce: data.busqueda,
      })
    );

    //Cargar las imagenes
    this.cargarListaImagenesVehiculo();
    //Cargar imagnes Ecommerce  <90467>
    this.cargarListaImagenesVehiculoEcommerce();
    //Cargar equipo seguimiento
    this.cargarListaEquipoSeguroVehiculo();

    //Cargar la ruta base del ambiente de Firebase
    this.props.fetchRutaFirebase().then(({ payload: { data } }) =>
      this.setState({
        stPrefijoRuta: data.busqueda,
      })
    );

    //Obtener el codigo autogenerado para la imagen
    this.props.fetchCodigoAutoImagen().then(({ payload: { data } }) =>
      this.setState({
        stCodigoAuto: data.busqueda,
      })
    );

    //Cargar colores por sku y los tapizes posibles de todos los colores
    console.log("fetchListarColorVehiculoSKU");
    console.log(skuvehiculo);
    var p_listaColores = [];
    const params = {
      skuSap: skuvehiculo.skuSap,
      codFamilia: skuvehiculo.codFamilia,
      codMarca: skuvehiculo.codMarca,
      codBaumuster: skuvehiculo.codBaumuster,
      codConfiguracion: skuvehiculo.codConfigVeh,
      codClausula: null, //skuvehiculo.p_cod_clau,
    };
    this.props
      .fetchListarColorVehiculoSKU(params)
      .then(({ payload: { data } }) =>
        //console.log(data.pinturaList)
        this.setState({ listaColorVeh: data.pinturaList })
      );
  }

  cargarListaCaracterTecnicaVehiculo() {
    document.addEventListener("click", toggleDiv, true);
    let { skuvehiculo } = this.props.location.state;
    //Cargar caracteristica tecnica vehiculo
    this.props
      .fetchCaracTecxVehiculo(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh
      )
      .then(({ payload: { data } }) =>
        this.setState({
          arrecaractecn: data.busqueda,
          totalRegCaract: data.totalRegistros,
          cantRegCaract: data.busqueda.length,
        })
      );
  }

  agregarParametrosCT = () => {
    const { arrecaractecn } = this.state;

    let nroOrdenMax = 0;
    arrecaractecn.map((arreglo) => {
      if (parseInt(arreglo.numeroOrden) > parseInt(nroOrdenMax)) {
        nroOrdenMax = arreglo.numeroOrden;
      }
    });

    const arreglo = {
      codFamilia: "",
      codMarca: "",
      codBaumuster: "",
      codConfiguracion: "",
      codCarTec: "",
      numeroOrden: parseInt(nroOrdenMax) + 1,
      descripcion: "",
      valor: "",
      indImpreso: "",
      indInactivo: "",
      operacion: "I",
      indImpWeb: "N",
      numOrdenWeb: undefined
    };
    this.setState({ arrecaractecn: [...arrecaractecn, arreglo] });
  };

  agregarParametrosIMG = () => {
    const arreimagenes = [...this.state.arreimagenes];

    const arregloimg = {
      picture: "",
      codFamilia: "",
      codMarca: "",
      codBaumuster: "",
      codConfiguracion: "",
      skuSap: "",
      txtRutaImagen: "",
      indInactivo: "N",
      tipoImagen: "0",
      numeroOrden: 0,
      alto: "",
      ancho: "",
      codImagen: "",
      operacion: "I",
      listaColorVehTapiz: [],
      indTipoWeb: "N",
    };
    this.setState({ arreimagenes: [...arreimagenes, arregloimg] });
  };


  agregarParametrosESV = () => {
    const { arrevehiculos } = this.state;

    const arreglo = {
      codFamilia: "",
      codMarca: "",
      codBaumuster: "",
      codConfiguracion: "",
      skuSap: "",
      txtEquipamiento: "",
      txtDetalle: "",
      numeroOrden: 0,
      indInactivo: "",
      codEquiSegVeg: "",
      operacion: "I",
    };
    this.setState({ arrevehiculos: [...arrevehiculos, arreglo] });
  };

  grabarEquipExter = (index) => {
    const { skuvehiculo } = this.props.location.state;
    const listaEquipExter = [...this.state.listaEquipExter];
    console.log('grabar');
    console.log(listaEquipExter);
    if (listaEquipExter.length > 0) {
      listaEquipExter.map((arreglo) => {
        const entidad = {
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
          codEquipoVeh: arreglo.codEquipoVeh,
          codTipoEquipoVeh: arreglo.codTipoEquipoVeh,
          indImpWeb: arreglo.p_indImpWeb != undefined
            ? arreglo.p_indImpWeb === true
              ? "S"
              : "N"
            : arreglo.indImpWeb,
          numOrdenWeb: arreglo.p_numOrdenWeb === undefined
            ? arreglo.numOrdenWeb
            : arreglo.p_numOrdenWeb
        }
        this.props.updateEquiVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");
            sessionStorage.setItem("pestania", 0);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      });
    }
  };

  grabarEquipInter = (index) => {
    const { skuvehiculo } = this.props.location.state;
    const listaEquipInter = [...this.state.listaEquipInter];
    console.log('grabar');
    console.log(listaEquipInter);
    if (listaEquipInter.length > 0) {
      listaEquipInter.map((arreglo) => {
        const entidad = {
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
          codEquipoVeh: arreglo.codEquipoVeh,
          codTipoEquipoVeh: arreglo.codTipoEquipoVeh,
          indImpWeb: arreglo.p_indImpWeb != undefined
            ? arreglo.p_indImpWeb === true
              ? "S"
              : "N"
            : arreglo.indImpWeb,
          numOrdenWeb: arreglo.p_numOrdenWeb === undefined
            ? arreglo.numOrdenWeb
            : arreglo.p_numOrdenWeb
        }
        this.props.updateEquiVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");
            sessionStorage.setItem("pestania", 0);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      });
    }
  };

  grabarParametroCT = (index) => {
    const { skuvehiculo } = this.props.location.state;
    const arrecaractecn = [...this.state.arrecaractecn];
    const arregloespejo = [...this.state.arrecaractecn];
    let entro = true;
    console.log("grabarParametroCT")
    //Validacion de los datos requeridos
    arrecaractecn.map((arreglo) => {
      const entidad = {
        codCaractVeh:
          arreglo.p_cartec === undefined ? arreglo.codCarTec : arreglo.p_cartec,
        valorCaract:
          arreglo.p_valor === undefined ? arreglo.valor : arreglo.p_valor,
      };

      if (entidad.valorCaract === "") {
        this.setState({ alertAdverValorReq: true });
        this.showAlert("alertAdverValorReq");
        entro = false;
      }
      if (entidad.codCaractVeh === "0" || entidad.codCaractVeh === "") {
        this.setState({ alertAdverCarTecReq: true });
        this.showAlert("alertAdverCarTecReq");
        entro = false;
      }
    });

    // Buscar es en espejo si hay datos repetidos
    if (entro === true) {
      let conta_orden = 0;
      let conta_cartec = 0;

      arrecaractecn.map((arreglo) => {
        if (entro === true) {
          const entidad = {
            numeroOrden:
              arreglo.p_nroorden === undefined
                ? arreglo.numeroOrden
                : arreglo.p_nroorden,
            codCaractVeh:
              arreglo.p_cartec === undefined
                ? arreglo.codCarTec
                : arreglo.p_cartec,
          };

          arregloespejo.map((espejo) => {
            const mirror = {
              numeroOrden:
                espejo.p_nroorden === undefined
                  ? espejo.numeroOrden
                  : espejo.p_nroorden,
              codCaractVeh:
                espejo.p_cartec === undefined
                  ? espejo.codCarTec
                  : espejo.p_cartec,
            };
            if (
              parseInt(entidad.numeroOrden) === parseInt(mirror.numeroOrden)
            ) {
              conta_orden++;
            }
            if (
              parseInt(entidad.codCaractVeh) === parseInt(mirror.codCaractVeh)
            ) {
              conta_cartec++;
            }
          });

          if (conta_orden === 1 && conta_cartec === 1) {
            conta_orden = 0;
            conta_cartec = 0;
          } else {
            entro = false;
          }
        }
      });

      if (parseInt(conta_cartec) > 1) {
        console.log("1")
        this.setState({ alertAdverCaracTec: true });
        this.showAlert("alertAdverCaracTec");
        entro = "false";
      }
      if (parseInt(conta_orden) > 1) {
        console.log("2")
        this.setState({ alertAdverNroOrden: true });
        this.showAlert("alertAdverNroOrden");
        entro = "false";
      }
    }
    // recorrido para grabar. Todos los valores estan completos y no hay valores repetidos.
    console.log("2")
    console.log(entro)
    if (entro === true) {
      arrecaractecn.map((arreglo) => {
        const entidad = {
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
          codBaumuster: skuvehiculo.codBaumuster,
          codConfig: skuvehiculo.codConfigVeh,
          codCaractVeh:
            arreglo.p_cartec === undefined
              ? arreglo.codCarTec
              : arreglo.p_cartec,
          numeroOrden:
            arreglo.p_nroorden === undefined
              ? arreglo.numeroOrden
              : arreglo.p_nroorden,
          valorCaract:
            arreglo.p_valor === undefined ? arreglo.valor : arreglo.p_valor,
          indImpresion:
            arreglo.p_imprimir != undefined
              ? arreglo.p_imprimir === true
                ? "S"
                : "N"
              : arreglo.indImpreso,
          indInactivo:
            arreglo.p_inactivo != undefined
              ? arreglo.p_inactivo === true
                ? "S"
                : "N"
              : arreglo.indInactivo,
          operacion: arreglo.operacion,
          //ecubas
          indImpWeb: arreglo.p_indImpWeb != undefined
            ? arreglo.p_indImpWeb === true
              ? "S"
              : "N"
            : arreglo.indImpWeb,
          numOrdenWeb: arreglo.p_numOrdenWeb === undefined
            ? arreglo.numOrdenWeb
            : arreglo.p_numOrdenWeb
          //ecubas
        };
        console.log(entidad)
        if (entidad.operacion != "I") {
          this.props.updateCarTecVeh(entidad).then(({ payload: { data } }) => {
            if (data.estadoTrama === "1") {
              this.setState({ alertSuccessOpenI: true });
              this.showAlert("alertSuccessOpenI");
              sessionStorage.setItem("pestania", 1);
              setTimeout(function () {
                window.location.reload();
              }, 2000);
            } else {
              this.setState({ alertErrorOpenI: true });
              this.showAlert("alertErrorOpenI");
            }
          });
        } else {
          this.props.createCarTecVeh(entidad).then(({ payload: { data } }) => {
            if (data.estadoTrama === "1") {
              this.setState({ alertSuccessOpenI: true });
              this.showAlert("alertSuccessOpenI");
              sessionStorage.setItem("pestania", 1);
              setTimeout(function () {
                window.location.reload();
              }, 2000);
            } else {
              this.setState({ alertErrorOpenI: true });
              this.showAlert("alertErrorOpenI");
            }
          });
        }
      });
    }
  };

  grabarParametroIMG = (index, strCodImagen) => {
    const { skuvehiculo } = this.props.location.state;
    const { estadoTrama } = this.state;
    const arretipimag = [...this.state.arretipimag]; //ecubas
    const arreimagenes = [...this.state.arreimagenes];
    const arregloespejo = [...this.state.arreimagenes];
    console.log(arreimagenes[index]);
    const { miFile, stPrefijoRuta, stCodigoAuto } = this.state;
    let entro = true;
    let p_tipImg =
      arreimagenes[index].p_tipoimg === undefined
        ? arreimagenes[index].tipoImagen
        : arreimagenes[index].p_tipoimg;
    let p_nroorden =
      arreimagenes[index].p_nroorden === undefined
        ? arreimagenes[index].numeroOrden
        : arreimagenes[index].p_nroorden;
    let p_alto =
      arreimagenes[index].p_alto === undefined
        ? arreimagenes[index].alto
        : arreimagenes[index].p_alto;
    let p_ancho =
      arreimagenes[index].p_ancho === undefined
        ? arreimagenes[index].ancho
        : arreimagenes[index].p_ancho;
    let p_colorVehiculo =
      arreimagenes[index].p_colorVehiculo === undefined
        ? arreimagenes[index].colorVehiculo
        : arreimagenes[index].p_colorVehiculo;
    let p_colorVehiculoTapiz =
      arreimagenes[index].p_colorVehiculoTapiz === undefined
        ? arreimagenes[index].colorVehiculoTapiz
        : arreimagenes[index].p_colorVehiculoTapiz;
    // let p_indTipoWeb =
    //   arreimagenes[index].undefined === undefined
    //     ? arreimagenes[index].indTipoWeb
    //     : arreimagenes[index].undefined;

    if (p_tipImg === "0" || p_tipImg === "") {
      this.setState({ alertAdverTipImgReq: true });
      this.showAlert("alertAdverTipImgReq");
      entro = false;
    }
    if (p_alto === "" || p_ancho === "") {
      this.setState({ alertAdverAdjArcReq: true });
      this.showAlert("alertAdverAdjArcReq");
      entro = false;
    }

    if (entro === true) {
      let conta_orden = 0;
      //Valido que no se repita nroOrden si es un registro nuevo
      let imagen_numeroorden = 0;
      let espejo_numeroorden = 0;

      arreimagenes.map((arreglo) => {
        if (entro === true) {
          imagen_numeroorden =
            arreglo.p_nroorden === undefined
              ? arreglo.numeroOrden
              : arreglo.p_nroorden;
          arregloespejo.map((espejo) => {
            espejo_numeroorden =
              espejo.p_nroorden === undefined
                ? espejo.numeroOrden
                : espejo.p_nroorden;
            if (imagen_numeroorden === espejo_numeroorden) {
              conta_orden++;
            }
          });
          if (parseInt(conta_orden) === 1) {
            conta_orden = 0;
          } else {
            entro = false;
          }
        }
      });
      if (parseInt(conta_orden) > 1) {
        this.setState({ alertAdverNroOrden: true });
        this.showAlert("alertAdverNroOrden");
      }
    }
    // recorrido para grabar. Todos los valores estan completos y no hay valores repetidos.
    if (entro === true) {
      // let p_numeroOrden = arreimagenes[index].p_nroorden=== undefined ?arreimagenes[index].numeroOrden : arreimagenes[index].p_nroorden;
      let p_ruta_img = "";
      if (miFile != undefined && miFile != "") {
        let indice = miFile.name.indexOf(".");
        let extension = miFile.name.substring(indice);
        p_ruta_img =
          "sku/" + skuvehiculo.skuSap + "_" + stCodigoAuto + extension;
      } else {
        p_ruta_img = arreimagenes[index].txtRutaImagen;
      }

      const entidad = {
        codFamilia: skuvehiculo.codFamilia,
        codMarca: skuvehiculo.codMarca,
        codBaumuster: skuvehiculo.codBaumuster,
        codConfiguracion: skuvehiculo.codConfigVeh,
        skuSap: skuvehiculo.skuSap,
        indInactivo: "N",
        numeroOrden:
          arreimagenes[index].p_nroorden === undefined
            ? arreimagenes[index].numeroOrden
            : arreimagenes[index].p_nroorden,
        tipoImagen:
          arreimagenes[index].p_tipoimg === undefined
            ? arreimagenes[index].tipoImagen
            : arreimagenes[index].p_tipoimg,
        alto:
          arreimagenes[index].p_alto === undefined
            ? arreimagenes[index].alto
            : arreimagenes[index].p_alto,
        ancho:
          arreimagenes[index].p_ancho === undefined
            ? arreimagenes[index].ancho
            : arreimagenes[index].p_ancho,
        colorVehiculo:
          arreimagenes[index].p_colorVehiculo === undefined
            ? arreimagenes[index].colorVehiculo
            : arreimagenes[index].p_colorVehiculo,
        colorVehiculoTapiz:
          arreimagenes[index].p_colorVehiculoTapiz === undefined
            ? arreimagenes[index].colorVehiculoTapiz
            : arreimagenes[index].p_colorVehiculoTapiz,
        txtRutaImagen: p_ruta_img,
        codImagen: strCodImagen,
      };
      console.log(entidad);
      if (strCodImagen != "") {
        //###EDICION
        this.props.updateImagenVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");

            sessionStorage.setItem("pestania", 4);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      } else {
        //###CREACION
        entidad.codImagen = stCodigoAuto;
        this.props.createImagenVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");

            const storageRef = storage.ref(`${stPrefijoRuta}/${p_ruta_img}`);

            storageRef.put(miFile); //Guardo en el Firebase
            sessionStorage.setItem("pestania", 4);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      }
    }
  };

  grabarParametroESV = (index, codEquipoSV) => {
    const { skuvehiculo } = this.props.location.state;
    const { estadoTrama } = this.state;
    const arrevehiculos = [...this.state.arrevehiculos];

    let entro = true;
    let p_equipamiento =
      arrevehiculos[index].p_equipamiento === undefined
        ? arrevehiculos[index].txtEquipamiento
        : arrevehiculos[index].p_equipamiento;
    let p_detalle =
      arrevehiculos[index].p_detalle === undefined
        ? arrevehiculos[index].txtDetalle
        : arrevehiculos[index].p_detalle;

    if (p_detalle === "") {
      this.setState({ alertAdverDetalleReq: true });
      this.showAlert("alertAdverDetalleReq");
      entro = false;
    }
    if (p_equipamiento === "") {
      this.setState({ alertAdverEquipoReq: true });
      this.showAlert("alertAdverEquipoReq");
      entro = false;
    }

    if (entro === true) {
      const entidad = {
        codFamilia: skuvehiculo.codFamilia,
        codMarca: skuvehiculo.codMarca,
        codBaumuster: skuvehiculo.codBaumuster,
        codConfiguracion: skuvehiculo.codConfigVeh,
        txtEquipamiento:
          arrevehiculos[index].p_equipamiento === undefined
            ? arrevehiculos[index].txtEquipamiento
            : arrevehiculos[index].p_equipamiento,
        txtDetalle:
          arrevehiculos[index].p_detalle === undefined
            ? arrevehiculos[index].txtDetalle
            : arrevehiculos[index].p_detalle,
        numeroOrden:
          arrevehiculos[index].p_nroorden === undefined
            ? arrevehiculos[index].numeroOrden
            : arrevehiculos[index].p_nroorden,
        indInactivo:
          arrevehiculos[index].p_inactivo != undefined
            ? arrevehiculos[index].p_inactivo === true
              ? "S"
              : "N"
            : arrevehiculos[index].indInactivo,
        codEquiSegVeh: codEquipoSV,
        skuSap: skuvehiculo.skuSap,
        operacion: arrevehiculos[index].operacion,
      };
      if (entidad.operacion != "I") {
        this.props.updateEquiSegVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");
            sessionStorage.setItem("pestania", 5);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      } else {
        this.props.createEquiSegVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");
            sessionStorage.setItem("pestania", 5);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      }
    }
  };

  cargarListaImagenesVehiculo() {
    document.addEventListener("click", toggleDiv, true);
    const { skuvehiculo } = this.props.location.state;

    this.props
      .fetchImagenVehiculo(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh
      )
      .then(({ payload: { data } }) => {
        console.log(data);
        data.busqueda.map((imagen) => {
          storage
            .ref()
            .child(`${imagen.txtRutaFirebase}`)
            .getDownloadURL()
            .then((url) => {
              const arregloimg = {
                picture: url,
                codFamilia: imagen.codFamilia,
                codMarca: imagen.codMarca,
                codBaumuster: imagen.codBaumuster,
                codConfiguracion: imagen.codConfiguracion,
                skuSap: imagen.skuSap,
                txtRutaImagen: imagen.txtRutaImagen,
                indInactivo: imagen.indInactivo,
                tipoImagen: imagen.tipoImagen,
                numeroOrden: imagen.numeroOrden,
                alto: imagen.alto,
                ancho: imagen.ancho,
                colorVehiculo: imagen.codColorVeh,
                colorVehiculoTapiz: imagen.codTapizVeh,
                indTipoWeb: imagen.indTipoWeb,
                codImagen: imagen.codImagen,
                //listaColorVehTapiz:listaColorVehTapiz,
                // listaColorVeh:listaColorVeh
              };
              const { arreimagenes } = this.state;
              this.setState({ arreimagenes: [...arreimagenes, arregloimg] });
            })
            .catch((error) => {
              const arregloimg = {
                picture: "",
                codFamilia: imagen.codFamilia,
                codMarca: imagen.codMarca,
                codBaumuster: imagen.codBaumuster,
                codConfiguracion: imagen.codConfiguracion,
                skuSap: imagen.skuSap,
                txtRutaImagen: imagen.txtRutaImagen,
                indInactivo: imagen.indInactivo,
                tipoImagen: imagen.tipoImagen,
                numeroOrden: imagen.numeroOrden,
                alto: imagen.alto,
                ancho: imagen.ancho,
                colorVehiculo: imagen.codColorVeh,
                colorVehiculoTapiz: imagen.codTapizVeh,
                indTipoWeb: imagen.indTipoWeb,
                codImagen: imagen.codImagen,
              };
              const { arreimagenes } = this.state;
              this.setState({ arreimagenes: [...arreimagenes, arregloimg] });
            });
        });
      });
    console.log("Acabó la lista de imagenes");
  }

  handleOnChange = (event, index) => {
    var arreimagenes = this.state.arreimagenes;
    let { stPrefijoRuta } = this.state;
    const file1 = event.target.files[0];
    this.state.miFile = file1;
    //Cargar la imagen y setear los valores en las cajas de Ancho y Alto.
    window.URL = window.URL || window.webkitURL;
    var elBrowse = document.getElementById("fileImagen"),
      elPreview = document.getElementById("img"),
      useBlob = false && window.URL;
    var reader = new FileReader();
    this.setState({ file: URL.createObjectURL(event.target.files[0]) });
    var imagenLoad = document.createElement("img");
    imagenLoad.src = URL.createObjectURL(event.target.files[0]);
    var st = this.state;

    imagenLoad.onload = function () {

      console.log(imagenLoad.width);
      console.log(imagenLoad.height);
      document.getElementById("p_ancho_" + index).value = imagenLoad.width;
      document.getElementById("p_alto_" + index).value = imagenLoad.height;
      arreimagenes[index].ancho = imagenLoad.width;
      arreimagenes[index].alto = imagenLoad.height;
      st.arreimagenes = arreimagenes;
    };
  };

  reset = () => {
    this.props.loadMantenimiento();
  };

  componentWillUnmount() {
    document.removeEventListener("click", toggleDiv, true);
  }

  loading = (status) => {
    this.setState({ muestraLoad: status });
  };

  onCheck = (e) => this.setState({ [e.target.name]: e.target.checked });

  onChangeValue = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  //ecubas 27/05
  onUpdateItemEquipoExterno = (e, i, checked) => {
    const listaEquipExter = this.state.listaEquipExter.map((item, j) => {
      if (j === i) {
        return {
          ...item,
          [e.target.name]:
            e.target.type === "checkbox" ? e.target.checked : e.target.value,
          //[e.target.name]: e.target.value
        };
      } else {
        return {
          ...item,
        };
      }
    });
    this.setState({ listaEquipExter });
  };

  onUpdateItemEquipoInterno = (e, i, checked) => {
    const listaEquipInter = this.state.listaEquipInter.map((item, j) => {
      if (j === i) {
        return {
          ...item,
          [e.target.name]:
            e.target.type === "checkbox" ? e.target.checked : e.target.value,
          //[e.target.name]: e.target.value
        };
      } else {
        return {
          ...item,
        };
      }
    });
    this.setState({ listaEquipInter });
  };
  //ecubas 27/05

  onUpdateItemImagenes = (e, i, checked) => {
    const arreimagenes = this.state.arreimagenes.map((item, j) => {
      if (j === i) {
        if ('p_tipoimg' === e.target.name) {
          item.tipoImagen = e.target.value
          return {
            ...item,
          };
        } else {
          return {
            ...item,
            [e.target.name]:
              e.target.type === "checkbox" ? e.target.checked : e.target.value,
          };
        }

      } else {
        return {
          ...item,
        };
      }
    });
    this.setState({ arreimagenes });
  };

  onUpdateItemVehiculos = (e, i, checked) => {
    const arrevehiculos = this.state.arrevehiculos.map((item, j) => {
      if (j === i) {
        return {
          ...item,
          [e.target.name]:
            e.target.type === "checkbox" ? e.target.checked : e.target.value,
          //[e.target.name]: e.target.value
        };
      } else {
        return {
          ...item,
        };
      }
    });
    this.setState({ arrevehiculos });
  };

  onUpdateItemCaractTec = (e, i, checked) => {
    const arrecaractecn = this.state.arrecaractecn.map((item, j) => {
      if (j === i) {
        return {
          ...item,
          [e.target.name]:
            e.target.type === "checkbox" ? e.target.checked : e.target.value,
          //[e.target.name]: e.target.value
        };
      } else {
        return {
          ...item,
        };
      }
    });
    this.setState({ arrecaractecn });
  };

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  };

  eliminarParametrosIMG = (e, index, codImagen) => {
    const { skuvehiculo } = this.props.location.state;
    const arreimagenes = [...this.state.arreimagenes];
    const { estadoTrama } = this.state;
    if (index > -1) {
      if (codImagen === "") {
        arreimagenes.splice(index, 1);
        this.setState({ arreimagenes });
      } else {
        const entidad = {
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
          codBaumuster: skuvehiculo.codBaumuster,
          codConfiguracion: skuvehiculo.codConfigVeh,
          codImagen: codImagen,
        };
        this.props.deleteImagenVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenD: true });
            this.showAlert("alertSuccessOpenD");
            sessionStorage.setItem("pestania", 4);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenD: true });
            this.showAlert("alertErrorOpenD");
          }
        });
      }
    }
  };

  eliminarParametrosESV = (e, index, codEsv) => {
    const { skuvehiculo } = this.props.location.state;
    const arrevehiculos = [...this.state.arrevehiculos];
    const { estadoTrama } = this.state;

    if (index > -1) {
      if (codEsv === "") {
        arrevehiculos.splice(index, 1);
        this.setState({ arrevehiculos });
      } else {
        const entidad = {
          codEsv: codEsv,
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
        };

        this.props.deleteEquiSegVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenD: true });
            this.showAlert("alertSuccessOpenD");
            sessionStorage.setItem("pestania", 5);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenD: true });
            this.showAlert("alertErrorOpenD");
          }
        });
      }
    }
  };

  eliminarParametrosCT = (e, index, codCaractVeh) => {
    const { skuvehiculo } = this.props.location.state;
    const arrecaractecn = [...this.state.arrecaractecn];
    const { estadoTrama } = this.state;
    if (index > -1) {
      if (codCaractVeh === "") {
        arrecaractecn.splice(index, 1);
        this.setState({ arrecaractecn });
      } else {
        const entidad = {
          codCaractVeh: codCaractVeh,
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
          codBaumuster: skuvehiculo.codBaumuster,
          codConfigur: skuvehiculo.codConfigVeh,
        };
        this.props.deleteCarTecVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenD: true });
            this.showAlert("alertSuccessOpenD");
            sessionStorage.setItem("pestania", 1);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenD: true });
            this.showAlert("alertErrorOpenD");
          }
        });
      }
    }
  };

  cargarListaEquipoSeguroVehiculo() {
    document.addEventListener("click", toggleDiv, true);
    const { skuvehiculo } = this.props.location.state;
    //Cargar equipo seguro
    this.props
      .fetchEquiSegVehiculo(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh
      )
      .then(({ payload: { data } }) =>
        this.setState({
          arrevehiculos: data.busqueda,
          totalRegSegVeh: data.totalRegistros,
          cantRegSegVeh: data.busqueda.length,
        })
      );
  }

  ///<90467-I> E C O M M E R C E 

  eliminarParametrosIMGEcommerce = (e, index, codImagen) => {
    const { skuvehiculo } = this.props.location.state;
    const arreimagenesEcommerce = [...this.state.arreimagenesEcommerce];
    const arreimagenesEcommerceList = [...this.state.arreimagenesEcommerceList];
    const { estadoTrama } = this.state;
    if (index > -1) {
      arreimagenesEcommerce.splice(index, 1);
      this.setState({ arreimagenesEcommerce });
      arreimagenesEcommerceList.splice(index, 1);
      this.setState({ arreimagenesEcommerceList });
      if (codImagen != "") {
        const entidad = {
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
          codBaumuster: skuvehiculo.codBaumuster,
          codConfiguracion: skuvehiculo.codConfigVeh,
          codImagen: codImagen,
        };
        this.props.deleteImagenVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenD: true });
            this.showAlert("alertSuccessOpenD");
            // setTimeout(function () {
            //   window.location.reload();
            // }, 2000);
          } else {
            this.setState({ alertErrorOpenD: true });
            this.showAlert("alertErrorOpenD");
          }
        });
      }
    }
  };

  onUpdateItemImagenesEcommerce = (e, i, checked) => {

    console.log(e);
    const arreimagenesEcommerceList = this.state.arreimagenesEcommerceList.map((item, j) => {
      if (j === i) {
        return {
          ...item,
          [e.target.name]:
            e.target.type === "checkbox" ? e.target.checked : e.target.value,
        };

      } else {
        return {
          ...item,
        };
      }
    });
    this.setState({ arreimagenesEcommerceList });
  };

  onChangeValueTipoimgEcommerceFiltro = (e) => {
    this.setState({ tipoimgEcommerceFiltro: e.target.value });
  };
  onChangeValueColorVehiculoEcommerceFiltro = (e) => {
    this.setState({ colorVehiculoEcommerceFiltro: e.target.value });
  };

  filtrarIMG = () => {
    if (this.state.tipoimgEcommerceFiltro != 0 &&
      this.state.colorVehiculoEcommerceFiltro == 0) {
      console.log("1");

      const arreimagenesEcommerceList1 = this.state.arreimagenesEcommerce.filter(
        (obj) =>
          obj.tipoImagen === this.state.tipoimgEcommerceFiltro
      )
      console.log(arreimagenesEcommerceList1)
      this.setState({ arreimagenesEcommerceList: arreimagenesEcommerceList1 });
      // sessionStorage.setItem("pestania", 7);
      // this.setState({ isActive: 7 });

    } else if (this.state.colorVehiculoEcommerceFiltro != 0 &&
      this.state.tipoimgEcommerceFiltro == 0) {
      console.log("2");
      const arreimagenesEcommerceList2 = this.state.arreimagenesEcommerce.filter(
        (obj) =>
          obj.colorVehiculo === this.state.colorVehiculoEcommerceFiltro
      )
      console.log(arreimagenesEcommerceList2)
      this.setState({ arreimagenesEcommerceList: arreimagenesEcommerceList2 });
      // sessionStorage.setItem("pestania", 6);
      // this.setState({ isActive: 6 });
    } else if (this.state.colorVehiculoEcommerceFiltro != 0 &&
      this.state.tipoimgEcommerceFiltro != 0) {
      console.log("3");
      const arreimagenesEcommerceList3 = this.state.arreimagenesEcommerce.filter(
        (obj) =>
          obj.tipoImagen === this.state.tipoimgEcommerceFiltro &&
          obj.colorVehiculo === this.state.colorVehiculoEcommerceFiltro
      )
      console.log(arreimagenesEcommerceList3)
      this.setState({ arreimagenesEcommerceList: arreimagenesEcommerceList3 });
      // sessionStorage.setItem("pestania", 6);
      // this.setState({ isActive: 6 });

    } else {
      console.log("mostrar mensaje de seleccion de filtros ");
    }

  };

  cargarListaImagenesVehiculoEcommerce() {
    document.addEventListener("click", toggleDiv, true);
    const { skuvehiculo } = this.props.location.state;

    this.props
      .fetchImagenVehiculoEcommerce(
        skuvehiculo.codFamilia,
        skuvehiculo.codMarca,
        skuvehiculo.codBaumuster,
        skuvehiculo.codConfigVeh
      )
      .then(({ payload: { data } }) => {
        console.log(data);
        data.busqueda.map((imagen) => {
          storage
            .ref()
            .child(`${imagen.txtRutaFirebase}`)
            .getDownloadURL()
            .then((url) => {
              const arregloimg = {
                picture: url,
                codFamilia: imagen.codFamilia,
                codMarca: imagen.codMarca,
                codBaumuster: imagen.codBaumuster,
                codConfiguracion: imagen.codConfiguracion,
                skuSap: imagen.skuSap,
                txtRutaImagen: imagen.txtRutaImagen,
                indInactivo: imagen.indInactivo,
                tipoImagen: imagen.tipoImagen,
                numeroOrden: imagen.numeroOrden,
                alto: imagen.alto,
                ancho: imagen.ancho,
                colorVehiculo: imagen.codColorVeh,
                colorVehiculoTapiz: imagen.codTapizVeh,
                indTipoWeb: imagen.indTipoWeb,
                codImagen: imagen.codImagen,
              };
              const { arreimagenesEcommerce } = this.state;
              this.setState({ arreimagenesEcommerce: [...arreimagenesEcommerce, arregloimg] });
              this.setState({ arreimagenesEcommerceList: [...arreimagenesEcommerce, arregloimg] });
            })
            .catch((error) => {
              const arregloimg = {
                picture: "",
                codFamilia: imagen.codFamilia,
                codMarca: imagen.codMarca,
                codBaumuster: imagen.codBaumuster,
                codConfiguracion: imagen.codConfiguracion,
                skuSap: imagen.skuSap,
                txtRutaImagen: imagen.txtRutaImagen,
                indInactivo: imagen.indInactivo,
                tipoImagen: imagen.tipoImagen,
                numeroOrden: imagen.numeroOrden,
                alto: imagen.alto,
                ancho: imagen.ancho,
                colorVehiculo: imagen.codColorVeh,
                colorVehiculoTapiz: imagen.codTapizVeh,
                indTipoWeb: imagen.indTipoWeb,
                codImagen: imagen.codImagen,
              };
              const { arreimagenesEcommerce } = this.state;
              this.setState({ arreimagenesEcommerce: [...arreimagenesEcommerce, arregloimg] });
              this.setState({ arreimagenesEcommerceList: [...arreimagenesEcommerce, arregloimg] });
            });
        });
      });
  }

  agregarParametrosIMGEcommerce = () => {
    //const arreimagenesEcommerce = [...this.state.arreimagenesEcommerce];
    const arreimagenesEcommerceList = [...this.state.arreimagenesEcommerceList];
    const ordenMax = Math.max.apply(Math, arreimagenesEcommerceList.map(function (o) { return o.numeroOrden; }))
    console.log(ordenMax);
    const arregloimg = {
      picture: "",
      codFamilia: "",
      codMarca: "",
      codBaumuster: "",
      codConfiguracion: "",
      skuSap: "",
      txtRutaImagen: "",
      indInactivo: "N",
      tipoImagen: "0",
      numeroOrden: ordenMax + 1,
      alto: 0,
      ancho: 0,
      codImagen: "",
      operacion: "I",
      colorVehiculo: 0,
      colorVehiculoTapiz: 0,
      listaColorVehTapiz: [],
      indTipoWeb: "N",
    };
    this.setState({ arreimagenesEcommerceList: [...arreimagenesEcommerceList, arregloimg] });
  };

  handleOnChangeEcommerce = (event, index) => {
    var arreimagenesEcommerce = this.state.arreimagenesEcommerceList;
    let { stPrefijoRuta } = this.state;
    const file1 = event.target.files[0];
    this.state.miFile = file1;
    //Cargar la imagen y setear los valores en las cajas de Ancho y Alto.
    window.URL = window.URL || window.webkitURL;
    var elBrowse = document.getElementById("fileImagen"),
      elPreview = document.getElementById("img"),
      useBlob = false && window.URL;
    var reader = new FileReader();
    this.setState({ file: URL.createObjectURL(event.target.files[0]) });
    var imagenLoad = document.createElement("img");
    imagenLoad.src = URL.createObjectURL(event.target.files[0]);
    var st = this.state;

    imagenLoad.onload = function () {

      console.log(imagenLoad.width);
      console.log(imagenLoad.height);
      document.getElementById("p_anchoEcommerce_" + index).value = imagenLoad.width;
      document.getElementById("p_altoEcommerce_" + index).value = imagenLoad.height;
      arreimagenesEcommerce[index].ancho = imagenLoad.width;
      arreimagenesEcommerce[index].alto = imagenLoad.height;
      st.arreimagenesEcommerce = arreimagenesEcommerce;
    };
  };

  grabarParametroIMGEcommerce = (index, strCodImagen) => {
    const { skuvehiculo } = this.props.location.state;
    const { estadoTrama } = this.state;
    const arretipimag = [...this.state.arreimagenesEcommerceList]; //ecubas
    const arreimagenes = [...this.state.arreimagenesEcommerceList];
    const arregloespejo = [...this.state.arreimagenesEcommerceList];
    const { miFile, stPrefijoRuta, stCodigoAuto } = this.state;
    let entro = true;
    let p_tipImg =
      arreimagenes[index].p_tipoimgEcommerce === undefined
        ? arreimagenes[index].tipoImagen
        : arreimagenes[index].p_tipoimgEcommerce;
    let p_nroorden =
      arreimagenes[index].p_nroordenEcommerce === undefined
        ? arreimagenes[index].numeroOrden
        : arreimagenes[index].p_nroordenEcommerce;
    let p_alto =
      arreimagenes[index].p_altoEcommerce === undefined
        ? arreimagenes[index].alto
        : arreimagenes[index].p_altoEcommerce;
    let p_ancho =
      arreimagenes[index].p_anchoEcommerce === undefined
        ? arreimagenes[index].ancho
        : arreimagenes[index].p_anchoEcommerce;
    let p_colorVehiculo =
      arreimagenes[index].p_colorVehiculo === undefined
        ? arreimagenes[index].colorVehiculo
        : arreimagenes[index].p_colorVehiculoEcommerce;
    let p_colorVehiculoTapiz =
      arreimagenes[index].p_colorVehiculoTapiz === undefined
        ? arreimagenes[index].colorVehiculoTapiz
        : arreimagenes[index].p_colorVehiculoTapizEcommerce;
    // let p_indTipoWeb =
    //   arreimagenes[index].undefined === undefined
    //     ? arreimagenes[index].indTipoWeb
    //     : arreimagenes[index].undefined;

    if (p_tipImg === "0" || p_tipImg === "") {
      this.setState({ alertAdverTipImgReq: true });
      this.showAlert("alertAdverTipImgReq");
      entro = false;
    }
    if (p_alto === "" || p_ancho === "") {
      this.setState({ alertAdverAdjArcReq: true });
      this.showAlert("alertAdverAdjArcReq");
      entro = false;
    }

    // recorrido para grabar. Todos los valores estan completos y no hay valores repetidos.
    if (entro === true) {
      // let p_numeroOrden = arreimagenes[index].p_nroorden=== undefined ?arreimagenes[index].numeroOrden : arreimagenes[index].p_nroorden;
      let p_ruta_img = "";
      if (miFile != undefined && miFile != "") {
        let indice = miFile.name.indexOf(".");
        let extension = miFile.name.substring(indice);
        p_ruta_img =
          "sku/" + skuvehiculo.skuSap + "_" + stCodigoAuto + extension;
      } else {
        p_ruta_img = arreimagenes[index].txtRutaImagen;
      }

      const entidad = {
        codFamilia: skuvehiculo.codFamilia,
        codMarca: skuvehiculo.codMarca,
        codBaumuster: skuvehiculo.codBaumuster,
        codConfiguracion: skuvehiculo.codConfigVeh,
        skuSap: skuvehiculo.skuSap,
        indInactivo: "N",
        numeroOrden:
          arreimagenes[index].p_nroordenEcommerce === undefined
            ? arreimagenes[index].numeroOrden
            : arreimagenes[index].p_nroordenEcommerce,
        tipoImagen:
          arreimagenes[index].p_tipoimgEcommerce === undefined
            ? arreimagenes[index].tipoImagen
            : arreimagenes[index].p_tipoimgEcommerce,
        alto:
          arreimagenes[index].p_altoEcommerce === undefined
            ? arreimagenes[index].alto
            : arreimagenes[index].p_altoEcommerce,
        ancho:
          arreimagenes[index].p_anchoEcommerce === undefined
            ? arreimagenes[index].ancho
            : arreimagenes[index].p_anchoEcommerce,
        colorVehiculo:
          arreimagenes[index].p_colorVehiculoEcommerce === undefined
            ? arreimagenes[index].colorVehiculo
            : arreimagenes[index].p_colorVehiculoEcommerce,
        colorVehiculoTapiz:
          arreimagenes[index].p_colorVehiculoTapizEcommerce === undefined
            ? arreimagenes[index].colorVehiculoTapiz
            : arreimagenes[index].p_colorVehiculoTapizEcommerce,
        txtRutaImagen: p_ruta_img,
        desEcommerce: miFile.name,
        codImagen: strCodImagen,
      };
      console.log(entidad);
      if (strCodImagen != "") {
        //###EDICION
        this.props.updateImagenVeh(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            //
            // 1. Make a shallow copy of the items
            let itemsList = [...this.state.arreimagenesEcommerceList];
            // 2. Make a shallow copy of the item you want to mutate
            let itemList = { ...itemsList[index] };
            console.log(itemList);
            // 3. Replace the property you're intested in
            itemList.codImagen = entidad.codImagen;
            itemList.colorVehiculo = entidad.colorVehiculo;
            itemList.codTapizVeh = entidad.codTapizVeh;
            itemList.numeroOrden = entidad.numeroOrden;
            // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
            itemsList[index] = itemList;
            // 5. Set the state to our new copy
            this.setState({ itemsList });

            //

            let items = [...this.state.arreimagenesEcommerce];
            // 2. Make a shallow copy of the item you want to mutate
            let item = { ...items[index] };
            console.log(item);
            // 3. Replace the property you're intested in
            item.codImagen = entidad.codImagen;
            item.colorVehiculo = entidad.colorVehiculo;
            item.codTapizVeh = entidad.codTapizVeh;
            item.numeroOrden = entidad.numeroOrden;
            // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
            items[index] = item;
            // 5. Set the state to our new copy
            this.setState({ items });


            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");

            // sessionStorage.setItem("pestania", 7);
            // setTimeout(function () {
            //   window.location.reload();
            // }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      } else {
        //###CREACION
        entidad.codImagen = stCodigoAuto;
        this.props.createImagenVehEcommerce(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            this.setState({ alertSuccessOpenI: true });
            this.showAlert("alertSuccessOpenI");

            const storageRef = storage.ref(`${stPrefijoRuta}/${p_ruta_img}`);

            storageRef.put(miFile); //Guardo en el Firebase
            sessionStorage.setItem("pestania", 7);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });
      }
    }
  };

  //Ecommerce Masivo
  agregarParametrosIMGEcommerceMasisvo = (alto, ancho, miFile) => {
    const arreimagenesEcommMas = [...this.state.arreimagenesEcommMas];

    const arregloimg = {
      picture: "",
      codFamilia: "",
      codMarca: "",
      codBaumuster: "",
      codConfiguracion: "",
      skuSap: "",
      txtRutaImagen: "",
      indInactivo: "N",
      tipoImagen: "0",
      numeroOrden: 0,
      alto: alto,
      ancho: ancho,
      codImagen: "",
      operacion: "I",
      indTipoWeb: "N",
      desEcommerce: miFile.name,
      miFile: miFile
    };
    this.setState({ arreimagenesEcommMas: [...arreimagenesEcommMas, arregloimg] });
  };
  //Ecommerce Masivo
  onDrop(files) {
    console.log(files);
    const { stPrefijoRuta, stCodigoAuto } = this.state;
    const { skuvehiculo } = this.props.location.state;
    this.setState({
      muestraLoad: 'block',
      basedatos: [],
      dataRows: [],
      selectedID: [],
    });


    files.forEach((miFile, i) => {
      console.log(miFile)

      this.props.fetchCodigoAutoImagen().then(({ payload: { data } }) =>
        this.setState({
          stCodigoAuto: data.busqueda,
        })
      );

      //--alto ancho
      var imagenLoad = document.createElement("img");
      imagenLoad.src = URL.createObjectURL(miFile);
      let alto = "";
      let ancho = "";
      imagenLoad.onload = function () {
        alto = imagenLoad.height;
        console.log(alto);
        ancho = imagenLoad.width;
        console.log(ancho);

      };
      setTimeout(() => {
        this.agregarParametrosIMGEcommerceMasisvo(alto, ancho, miFile);
      }, 500);

    });

  }
  //Ecommerce Masivo
  grabarEcommerceMasivo = () => {
    console.log("grabarEcommerceMasivo");
    //
    const arreimagenesEcommMas = [...this.state.arreimagenesEcommMas];
    const { stPrefijoRuta, stCodigoAuto } = this.state;
    const { skuvehiculo } = this.props.location.state;
    console.log('grabar');
    if (arreimagenesEcommMas.length > 0) {
      arreimagenesEcommMas.map((arreglo, i) => {
        console.log(i)
        let p_ruta_img = "";
        if (arreglo.miFile != undefined && arreglo.miFile != "") {
          let indice = arreglo.miFile.name.indexOf(".");
          let extension = arreglo.miFile.name.substring(indice);
          //Obtener el codigo autogenerado para la imagen
          p_ruta_img =
            "sku/" + skuvehiculo.skuSap + "_" + (Number(stCodigoAuto) + i) + extension;
        }

        //unavez la lista llena se inserta recorriendola
        console.log(p_ruta_img);
        const entidad = {
          codFamilia: skuvehiculo.codFamilia,
          codMarca: skuvehiculo.codMarca,
          codBaumuster: skuvehiculo.codBaumuster,
          codConfiguracion: skuvehiculo.codConfigVeh,
          skuSap: skuvehiculo.skuSap,
          indInactivo: "N",
          numeroOrden: i + 1,
          tipoImagen:
            this.state.ecommerceCargaMasTipImg === undefined
              ? null
              : this.state.ecommerceCargaMasTipImg,
          alto: arreglo.alto,
          ancho: arreglo.ancho,
          colorVehiculo:
            this.state.ecommerceCargaMasColVeh === undefined
              ? null
              : this.state.ecommerceCargaMasColVeh,
          colorVehiculoTapiz:
            this.state.ecommerceCargaMasColTap === undefined
              ? null
              : this.state.ecommerceCargaMasColTap,
          txtRutaImagen: p_ruta_img,
          desEcommerce: arreglo.desEcommerce,
          codImagen: Number(stCodigoAuto) + i,
          miFile: arreglo.miFile
        };

        this.props.createImagenVehEcommerce(entidad).then(({ payload: { data } }) => {
          if (data.estadoTrama === "1") {
            const storageRef = storage.ref(`${stPrefijoRuta}/${entidad.txtRutaImagen}`);
            storageRef.put(entidad.miFile); //Guardo en el Firebase
            console.log((arreimagenesEcommMas.length - 1) === i);
            if ((arreimagenesEcommMas.length - 1) === i) {
              this.setState({ alertSuccessOpenI: true });
              this.showAlert("alertSuccessOpenI");
              sessionStorage.setItem("pestania", 0);
              setTimeout(function () {
                window.location.reload();
              }, 2000);
            }
          } else {
            this.setState({ alertErrorOpenI: true });
            this.showAlert("alertErrorOpenI");
          }
        });


      });
    }


  }

  onChangeValueEcommerceCargaMasivaTipImg = (e) => {
    this.setState({ ecommerceCargaMasTipImg: e.target.value });
  };
  onChangeValueEcommerceCargaMasivaColVeh = (e) => {
    this.setState({ ecommerceCargaMasColVeh: e.target.value });
  };
  onChangeValueEcommerceCargaMasivaColTap = (e) => {
    this.setState({ ecommerceCargaMasColTap: e.target.value });
  };

  ///<90467-F> E C O M M E R C E 

  render() {
    const { mantenimientoSkuVehiculo } = this.props;
    const {
      listaEquipInter,
      listaEquipExter,
      listaCaracter,
      listaEspecTecn,
      listaAccesorio,
      listaImagen,
      arrevehiculos,
      arreimagenes,
      arreimagenesEcommerce,
      arreimagenesEcommerceList,
      arretipimag,
      arretipimagEcommerce,
      arrecaractecn,
      arretbcaractec,
      estadoTrama,
      listaColorVeh,
    } = this.state;
    return (
      <div className="pageHead-rowContainer">
        <PageHeader
          title="Sku de Vehículos - Detalle"
          buttonName="Volver"
          link={"/mantenimiento-sku-vehiculo"}
        />

        <div className="wrapper" style={{ marginTop: "10px" }}>
          {this.InterfazDetalle()}
          <div className="tabs-hr">
            <ul className="tabs" role="tablist">
              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 0 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 0 })}
                  role="tab"
                  aria-controls="equipos"
                  data-toggle="tab"
                >
                  Equipos
                </a>
              </li>
              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 1 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 1 })}
                  role="tab"
                  aria-controls="carac_tec"
                  data-toggle="tab"
                >
                  Características técnicas
                </a>
              </li>
              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 2 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 2 })}
                  role="tab"
                  aria-controls="espec_tec"
                  data-toggle="tab"
                >
                  Especificaciones técnicas
                </a>
              </li>
              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 3 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 3 })}
                  role="tab"
                  aria-controls="espec_tec"
                  data-toggle="tab"
                >
                  Accesorios Aduaneros
                </a>
              </li>
              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 4 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 4 })}
                  role="tab"
                  aria-controls="imagenes"
                  data-toggle="tab"
                >
                  Imagenes
                </a>
              </li>
              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 5 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 5 })}
                  role="tab"
                  aria-controls="equi_seg"
                  data-toggle="tab"
                >
                  Equipamiento de seguridad de serie
                </a>
              </li>

              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 6 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 6 })}
                  role="tab"
                  aria-controls="img_ecommerce_carga_mas"
                  data-toggle="tab"
                >
                  Ecommerce Carga Masiva
                </a>
              </li>
              <li
                role="presentation"
                className={`tabs-item ${
                  this.state.isActive === 7 ? "active" : null
                  }`}
              >
                <a
                  className="tabs-item-link"
                  onClick={() => this.setState({ isActive: 7 })}
                  role="tab"
                  aria-controls="img_ecommerce"
                  data-toggle="tab"
                >
                  Imagenes Ecommerce
                </a>
              </li>
            </ul>
          </div>

          <div className="tab-content">
            <section
              className={`tab-pane ${
                this.state.isActive === 0 ? "active" : null
                }`}
              id="equipos"
            >
              {this.InterfazEquipoE(listaEquipExter)}
              {this.InterfazEquipoI(listaEquipInter)}
            </section>

            <section
              className={`tab-pane ${
                this.state.isActive === 1 ? "active" : null
                }`}
              id="carac_tec"
            >
              {this.InterfazCaracteristica(arrecaractecn, arretbcaractec)}
            </section>

            <section
              className={`tab-pane ${
                this.state.isActive === 2 ? "active" : null
                }`}
              id="espec_tec"
            >
              {this.InterfazEspecificacion(listaEspecTecn)}
            </section>

            <section
              className={`tab-pane ${
                this.state.isActive === 3 ? "active" : null
                }`}
              id="acces_acc"
            >
              {this.InterfazAccesorio(listaAccesorio)}
            </section>
            <section
              className={`tab-pane ${
                this.state.isActive === 4 ? "active" : null
                }`}
              id="int_img"
            >
              {this.InterfazImagen(arreimagenes, arretipimag, listaColorVeh)}
            </section>
            <section
              className={`tab-pane ${
                this.state.isActive === 5 ? "active" : null
                }`}
              id="int_eqSeg"
            >
              {this.InterfazEquiSeg(arrevehiculos)}
            </section>
            <section
              className={`tab-pane ${
                this.state.isActive === 6 ? "active" : null
                }`}
              id="int_ecomCarga"
            >
              {this.InterfazEcommerceCargaMasiva(arreimagenes, arretipimagEcommerce, listaColorVeh)}
            </section>
            <section
              className={`tab-pane ${
                this.state.isActive === 7 ? "active" : null
                }`}
              id="img_ecommerce"
            >
              {this.InterfazEcommerce(arreimagenesEcommerce, arreimagenesEcommerceList, arretipimagEcommerce, listaColorVeh)}
            </section>
          </div>
        </div>
        {this.state.alertAdverValorReq && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverValorReq}
          >
            <p>Ingrese el valor</p>
          </Alert>
        )}

        {this.state.alertAdverCarTecReq && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverCarTecReq}
          >
            <p>Seleccionar el tipo de caracteristica</p>
          </Alert>
        )}

        {this.state.alertAdverAdjArcReq && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverAdjArcReq}
          >
            <p>Seleccionar el archivo de imagen</p>
          </Alert>
        )}

        {this.state.alertAdverTipImgReq && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverTipImgReq}
          >
            <p>Seleccionar el Tipo de Imagen</p>
          </Alert>
        )}

        {this.state.alertAdverNroOrden && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverNroOrden}
          >
            <p>El número de orden no puede ser repetido</p>
          </Alert>
        )}
        {this.state.alertAdverCaracTec && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverCarTec}
          >
            <p>El tipo de característica no puede ser repetido</p>
          </Alert>
        )}

        {this.state.alertAdverDetalleReq && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverDetalleReq}
          >
            <p>Ingrese el detalle</p>
          </Alert>
        )}

        {this.state.alertAdverEquipoReq && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertAdverEquipoReq}
          >
            <p>Ingrese el equipo</p>
          </Alert>
        )}

        {this.state.alertErrorOpenI && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertErrorI}
          >
            <p>Hubo un error al grabar el registro</p>
          </Alert>
        )}
        {this.state.alertSuccessOpenI && (
          <Alert
            type="alert-success"
            icon="ion-checkmark-circled"
            closeAlert={this.closeAlertSuccessI}
          >
            <p>Se guardó correctamente el registro</p>
          </Alert>
        )}
        {this.state.alertErrorOpenD && (
          <Alert
            type="alert-warning"
            icon="ion-alert-circled"
            closeAlert={this.closeAlertErrorD}
          >
            <p>Hubo un error al eliminar el registro</p>
          </Alert>
        )}
        {this.state.alertSuccessOpenD && (
          <Alert
            type="alert-success"
            icon="ion-checkmark-circled"
            closeAlert={this.closeAlertSuccessD}
          >
            <p>Se eliminó correctamente el registro</p>
          </Alert>
        )}
      </div>
    );
  } /*@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ Final del Render @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@*/

  InterfazCaracteristica(arrecaractecn, arretbcaractec) {
    if (this.state.isActive === 1) {
      return (
        <div className="wrapper tableFdv">
          <div className="tableWrapper">
            <ListadoCaracTecVehiculoDinamico
              agregarParametrosCT={this.agregarParametrosCT}
              eliminarParametrosCT={this.eliminarParametrosCT}
              grabarParametroCT={this.grabarParametroCT}
              onUpdateItem={this.onUpdateItemCaractTec}
              arrecaractecn={this.state.arrecaractecn}
              arretbcaractec={this.state.arretbcaractec}
              state={this.state}
              estadoTrama={this.state.estadoTrama}
            />
          </div>
        </div>
      );
    }
  }

  InterfazEquiSeg(arrevehiculos) {
    if (this.state.isActive === 5) {
      //Recorrer la lista y setearlo en el array. El que viajara es el array y no la lista
      // arrevehiculos.push(listaEquiSeg);
      //===================================================================================
      return (
        <div className="wrapper tableFdv">
          <div className="tableWrapper">
            <ListadoEquiSegVehiculoDinamico
              agregarParametrosESV={this.agregarParametrosESV}
              eliminarParametrosESV={this.eliminarParametrosESV}
              grabarParametroESV={this.grabarParametroESV}
              onUpdateItem={this.onUpdateItemVehiculos}
              arrevehiculos={this.state.arrevehiculos}
              estadoTrama={this.state.estadoTrama}
            />
          </div>
        </div>
      );
    }
  }

  closeAlertErrorI = () => this.setState({ alertErrorOpenI: false });
  closeAlertSuccessI = () => this.setState({ alertSuccessOpenI: false });
  closeAlertErrorD = () => this.setState({ alertErrorOpenD: false });
  closeAlertSuccessD = () => this.setState({ alertSuccessOpenD: false });
  //Pestaña CARACTERISTICAS TECNICAS
  closeAlertAdverCarTecReq = () =>
    this.setState({ alertAdverCarTecReq: false });
  closeAlertAdverValorReq = () => this.setState({ alertAdverValorReq: false });
  closeAlertAdverNroOrden = () => this.setState({ alertAdverNroOrden: false });
  closeAlertAdverCarTec = () => this.setState({ alertAdverCaracTec: false });
  // Pestaña IMAGENES
  closeAlertAdverTipImgReq = () =>
    this.setState({ alertAdverTipImgReq: false });
  closeAlertAdverAdjArcReq = () =>
    this.setState({ alertAdverAdjArcReq: false });
  // Pestaña SEGURIDAD EQUIPO VEHICULO
  closeAlertAdverEquipoReq = () =>
    this.setState({ alertAdverEquipoReq: false });
  closeAlertAdverDetalleReq = () =>
    this.setState({ alertAdverDetalleReq: false });

  InterfazAccesorio(listaAccesorio) {
    if (this.state.isActive === 3) {
      return (
        <div className="wrapper">
          <div className="tableWrapper">
            <table
              className="table table-hover"
              style={{ marginBottom: "20px" }}
            >
              <thead className="table-head">
                <tr>
                  <th>Codigo</th>
                  <th>Descripcion</th>
                  <th>Valor</th>
                  <th>Inactivo</th>
                </tr>
              </thead>
              {listaAccesorio ? (
                <ListadoAccAduaVehiculo aasvehiculo={listaAccesorio} />
              ) : (
                  <tbody>
                    <tr>
                      <td colSpan={9}>
                        <FadeLoader color={"#F8A14A"} loading />
                      </td>
                    </tr>
                  </tbody>
                )}
            </table>
          </div>
        </div>
      );
    }
  }

  InterfazEquipoE(listaEquipExter) {
    if (this.state.isActive === 0) {
      return (
        <div className="wrapper">
          <div className="tableWrapper">
            <br />
            <div align="right">
              <button className="btn btn-orange-p" onClick={() => this.grabarEquipExter()} style={{ width: "95px" }}>
                Guardar
              </button>
            </div>
            <label htmlFor="listaExterna">
              <h3>Equipamiento Exterior</h3>
            </label>
            <table
              className="table table-hover"
              style={{ marginBottom: "20px" }}
            >
              <thead className="table-head">
                <tr>
                  <th>Codigo</th>
                  <th>Equipo</th>
                  <th>Tipo</th>
                  <th>Cantidad</th>
                  <th>Revisión</th>
                  <th>Entrega</th>
                  <th>Impresión</th>
                  <th>Inactivo</th>
                  <th>Web</th>
                  <th>Orden Web</th>
                </tr>
              </thead>
              {listaEquipExter ? (
                <ListadoEquipoExterno
                  equisvehiculoE={listaEquipExter}
                  onUpdateItem={this.onUpdateItemEquipoExterno} />
              ) : (
                  <tbody>
                    <tr>
                      <td colSpan={8}>
                        <FadeLoader color={"#F8A14A"} loading />
                      </td>
                    </tr>
                  </tbody>
                )}
            </table>
          </div>
        </div>
      );
    }
  }

  InterfazEquipoI(listaEquipInter) {
    if (this.state.isActive === 0) {
      return (
        <div className="wrapper">
          <div className="tableWrapper">
            <div align="right">
              <button className="btn btn-orange-p" onClick={() => this.grabarEquipInter()} style={{ width: "95px" }}>
                Guardar
              </button>
            </div>
            <label className="labelInfo" htmlFor="listaInterna">
              <h3>Equipamiento Interior</h3>
            </label>
            <table
              className="table table-hover"
              style={{ marginBottom: "20px" }}
            >
              <thead className="table-head">
                <tr>
                  <th>Codigo</th>
                  <th>Equipo</th>
                  <th>Tipo</th>
                  <th>Cantidad</th>
                  <th>Revisión</th>
                  <th>Entrega</th>
                  <th>Impresión</th>
                  <th>Inactivo</th>
                  <th>Web</th>
                  <th>Orden Web</th>
                </tr>
              </thead>
              {listaEquipInter ? (
                <ListadoEquipoInterno
                  equisvehiculoI={listaEquipInter}
                  onUpdateItem={this.onUpdateItemEquipoInterno} />
              ) : (
                  <tbody>
                    <tr>
                      <td colSpan={8}>
                        <FadeLoader color={"#F8A14A"} loading />
                      </td>
                    </tr>
                  </tbody>
                )}
            </table>
          </div>
        </div>
      );
    }
  }

  InterfazEspecificacion(listaEspecTecn) {
    if (this.state.isActive === 2) {
      return (
        <div className="wrapper">
          <div className="tableWrapper">
            <table
              className="table table-hover"
              style={{ marginBottom: "20px" }}
            >
              <thead className="table-head">
                <tr>
                  <th>Código</th>
                  <th>Especificación Tecnica</th>
                  <th>Valor</th>
                  <th>Inactivo</th>
                </tr>
              </thead>
              {listaEspecTecn ? (
                <ListadoEspecTecVehiculo etsvehiculo={listaEspecTecn} />
              ) : (
                  <tbody>
                    <tr>
                      <td colSpan={9}>
                        <FadeLoader color={"#F8A14A"} loading />
                      </td>
                    </tr>
                  </tbody>
                )}
            </table>
          </div>
        </div>
      );
    }
  }

  InterfazDetalle() {
    //IMPORTANTE EL DETALLE DE LOS SKUS
    return (
      <div className="wrapper">
        <div className="row" style={{ marginTop: "12px" }}>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="Familia">
              Familia
            </label>
            <input
              className="form-control"
              id="familia"
              name="familia"
              type="text"
              value={this.state.familia}
            />
          </div>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="Marca">
              Marca
            </label>
            <input
              className="form-control"
              id="marca"
              name="marca"
              type="text"
              value={this.state.marca}
            />
          </div>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="Modelo">
              Modelo
            </label>
            <input
              className="form-control"
              id="modelo"
              name="modelo"
              type="text"
              value={this.state.modelo}
            />
          </div>
          <div className="col-md-3">
            <label className="labelInfo" htmlFor="Configuracion">
              Configuracion
            </label>
            <input
              className="form-control"
              id="config"
              name="config"
              type="text"
              value={this.state.configuracion}
            />
          </div>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="SkuSap">
              Sku Sap
            </label>
            <input
              className="form-control"
              id="skuSap"
              name="skuSap"
              type="text"
              value={this.state.skuSap}
            />
          </div>
          <div className="col-md-2"></div>
        </div>
        <div className="row" style={{ marginTop: "6px" }}>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="Numero variante">
              Nro Variante
            </label>
            <input
              className="form-control"
              id="nroVariante"
              name="nroVariante"
              type="text"
              value={this.state.variante}
            />
          </div>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="Tipo Vehiculo">
              Tipo Vehiculo
            </label>
            <input
              className="form-control"
              id="tipoVehiculo"
              name="tipoVehiculo"
              type="text"
              value={this.state.tipoVehiculo}
            />
          </div>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="Tipo Sku">
              Tipo Sku
            </label>
            <input
              className="form-control"
              id="tipoSku"
              name="tipoSku"
              type="text"
              value={this.state.tipoSku}
            />
          </div>
          <div className="col-md-3">
            <label className="labelInfo" htmlFor="Combustible">
              Combustible
            </label>
            <input
              className="form-control"
              id="combustible"
              name="combustible"
              type="text"
              value={this.state.combustible}
            />
          </div>
          <div className="col-md-2">
            <label className="labelInfo" htmlFor="Reporte Euro">
              Reporte Euro
            </label>
            <input
              className="form-control"
              id="reporteEuro"
              name="reporteEuro"
              type="text"
              value={this.state.reporteEuro}
            />
          </div>
          <div>
            <label className="labelInfo" htmlFor="Inactivo">
              Inactivo
            </label>
            <label
              className="labelInfo"
              style={{ fontSize: "17px", marginTop: "5px" }}
            >
              {" "}
              &nbsp;&nbsp;{this.state.inactivo === "S" ? "SI" : "NO"}
            </label>
          </div>
        </div>
      </div>
    );
  }

  InterfazImagen(arreimagenes, arretipimag, listaColorVeh) {
    if (this.state.isActive === 4) {
      console.log(arreimagenes);
      console.log(listaColorVeh);
      console.log(arretipimag);
      return (
        <div className="wrapper tableFdv">
          <div className="tableWrapper">
            <ListadoImagenVehiculoDinamico
              agregarParametrosIMG={this.agregarParametrosIMG}
              ordenarListaPorOrden={this.ordenarListaPorOrden}
              eliminarParametrosIMG={this.eliminarParametrosIMG}
              grabarParametroIMG={this.grabarParametroIMG}
              onUpdateItem={this.onUpdateItemImagenes}
              validaItemWeb={this.validaItemWeb}
              arreimagenes={this.state.arreimagenes}
              arretipimag={this.state.arretipimag}
              listaColorVeh={this.state.listaColorVeh}
              state={this.state}
              imageFile={this.state.file}
              handleOnChange={this.handleOnChange}
            />
          </div>
        </div>
      );
    }
  }

  InterfazEcommerceCargaMasiva(arreimagenesEcommerce, arretipimagEcommerce, listaColorVeh) {
    if (this.state.isActive === 6) {

      return (
        <SeleccionarAdjuntoEcommerce
          arretipimag={this.state.arretipimagEcommerce}
          arrevehiculos={this.state.arrevehiculos}
          listaColorVeh={this.state.listaColorVeh}
          estadoTrama={this.state.estadoTrama}
          arreimagenesEcommMas={this.state.arreimagenesEcommMas}
          listaEcommerceCargaMas={this.state.listaEcommerceCargaMas}
          ecommerceCargaMasTipImg={this.state.ecommerceCargaMasTipImg}
          ecommerceCargaMasColVeh={this.state.ecommerceCargaMasColVeh}
          ecommerceCargaMasColTap={this.state.ecommerceCargaMasColTap}
          //PASARLE COLOR VEH
          //LOGICA DE MOTRART  COLOR TAPIZ
          onChangeValueTipImg={this.onChangeValueEcommerceCargaMasivaTipImg}
          onChangeValueColVeh={this.onChangeValueEcommerceCargaMasivaColVeh}
          onChangeValueColTap={this.onChangeValueEcommerceCargaMasivaColTap}
          agregarParametrosIMGEcommMas={this.agregarParametrosIMGEcommerceMasisvo}
          grabarEcommerceMasivo={this.grabarEcommerceMasivo}
          state={this.state}
          onDrop={this.onDrop}
        />
      );
    }
  }

  InterfazEcommerce(arreimagenesEcommerce, arreimagenesEcommerceList, arretipimagEcommerce, listaColorVeh) {
    if (this.state.isActive === 7) {
      console.log("InterfazEcommerce");
      //console.log(arreimagenesEcommerce);
      console.log(this.state.arreimagenesEcommerceList);
      return (
        <div className="wrapper tableFdv">
          <div className="tableWrapper">
            <ListadoImagenDinamicoEcommerce
              agregarParametrosIMGEcommerce={this.agregarParametrosIMGEcommerce}
              ordenarListaPorOrden={this.ordenarListaPorOrden}
              eliminarParametrosIMG={this.eliminarParametrosIMGEcommerce}
              grabarParametroIMG={this.grabarParametroIMGEcommerce}
              onUpdateItem={this.onUpdateItemImagenesEcommerce}
              filtrarIMG={this.filtrarIMG}
              validaItemWeb={this.validaItemWeb}
              arreimagenesEcommerce={this.state.arreimagenesEcommerce}
              arreimagenesEcommerceList={this.state.arreimagenesEcommerceList}
              arretipimag={this.state.arretipimagEcommerce}
              listaColorVeh={this.state.listaColorVeh}
              state={this.state}
              imageFile={this.state.file}
              handleOnChange={this.handleOnChangeEcommerce}
              onChangeValueTipoimgEcommerceFiltro={this.onChangeValueTipoimgEcommerceFiltro}
              onChangeValueColorVehiculoEcommerceFiltro={this.onChangeValueColorVehiculoEcommerceFiltro}
            />
          </div>
        </div>
      );
    }
  }


}

function mapStateToProps(state) {
  return {};
}
SkuVehiculoDetalle.defaultProps = {};

export default connect(mapStateToProps, {
  fetchEquiposxVehiculo,
  fetchCaracTecxVehiculo,
  fetchEspecTecxVehiculo,
  fetchAccAduaxVehiculo,
  fetchImagenVehiculo,
  fetchImagenVehiculoEcommerce,
  fetchEquiSegVehiculo,
  loadMantenimiento,
  createEquiSegVeh,
  deleteEquiSegVeh,
  createImagenVeh,
  createImagenVehEcommerce,
  deleteImagenVeh,
  fetchTipoImagen,
  fetchTipoImagenEcommerce,
  updateCarTecVeh,
  fetchCaracterTecnica,
  deleteCarTecVeh,
  createCarTecVeh,
  fetchRutaFirebase,
  updateEquiSegVeh,
  updateEquiVeh,
  updateImagenVeh,
  fetchCodigoAutoImagen,
  fetchListarColorVehiculoSKU,
  fetchListarColorVehiculoInteriorSKU,
})(SkuVehiculoDetalle);



// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/SkuVehiculoDetalle.js